import type { User } from "firebase/auth";
import type { PolarProduct, Project } from "../types/api";

export interface LibraryEntry {
  id: string;
  name: string;
  dataUrl: string;
  source: "upload" | "sample" | string;
}

export type ScreenName =
  | "overview"
  | "studio"
  | "hair"
  | "closet"
  | "pricing"
  | "account"
  | "faq";

export interface AppState {
  user: User | null;
  idToken: string | null;
  activeScreen: ScreenName;
  billingConfigured: boolean;
  productMap: Map<string, string>;
  productDetailsById: Map<string, PolarProduct>;
  activeSubscriptionProductIds: Set<string>;
  projects: Project[];
  projectPollTimer: number | null;
  selectedOutfitPerson: LibraryEntry | null;
  selectedHairPerson: LibraryEntry | null;
  selectedOutfitGarments: LibraryEntry[];
  selectedOutfitStyle: string;
  personLibrary: LibraryEntry[];
  garmentLibrary: LibraryEntry[];
}

export const state: AppState = {
  user: null,
  idToken: null,
  activeScreen: "overview",
  billingConfigured: false,
  productMap: new Map<string, string>(),
  productDetailsById: new Map<string, PolarProduct>(),
  activeSubscriptionProductIds: new Set<string>(),
  projects: [],
  projectPollTimer: null,
  selectedOutfitPerson: null,
  selectedHairPerson: null,
  selectedOutfitGarments: [],
  selectedOutfitStyle: "",
  personLibrary: [],
  garmentLibrary: [],
};
